module.exports = __webpack_public_path__ + "static/magnus-logo-c75d5db733b927d2ded679b7615295b6.png";